module.exports = new __parcel__URL__("snare_3.3b5c10f7.mp3").toString();